const FIRST = {
  boutique: "sklep", poeles: "piece", granules: "pellet", accessoires: "akcesoria", favoris: "ulubione", packs: "zestawy", produit: "produkt",
  calculateur: "kalkulator", livraison: "dostawa", installation: "montaz", devis: "wycena", contact: "kontakt", aide: "pomoc", "a-propos": "o-nas",
  legal: "informacje", conseils: "porady", panier: "koszyk", commande: "zamowienie", paiement: "platnosc", connexion: "logowanie",
  reinitialiser: "reset-hasla", compte: "konto",
};
const SECOND = {
  commande: { confirmation: "potwierdzenie" },
  paiement: { succes: "sukces" },
  compte: { commandes: "zamowienia", factures: "faktury", adresses: "adresy", paiement: "platnosci", favoris: "ulubione", devis: "wyceny", demandes: "zgloszenia", abonnements: "subskrypcje", avis: "opinie", fidelite: "lojalnosc", donnees: "dane" },
  legal: { "mentions-legales": "nota-prawna", cgv: "regulamin-sprzedazy", confidentialite: "polityka-prywatnosci", cookies: "polityka-cookies", "politique-livraison": "polityka-dostawy", retours: "zwroty-i-reklamacje", "conditions-utilisation": "regulamin-strony", "donnees-personnelles": "dane-osobowe" },
  boutique: { "bois-de-chauffage": "drewno-kominkowe", "buches-densifiees": "brykiet-drzewny", "bois-allumage": "rozpalka", briquettes: "brykiety", granules: "pellet-drzewny", "poeles-bois": "piece-na-drewno", "poeles-granules": "piece-na-pellet", inserts: "wklady-kominkowe", accessoires: "akcesoria-kominkowe", entretien: "konserwacja", stockage: "przechowywanie-drewna", packs: "pakiety", "palettes-vrac": "palety-tria-luzem" },
};
export const ACCOUNT_TABS = SECOND.compte;
export const ACCOUNT_TAB_FROM_PL = Object.fromEntries(Object.entries(ACCOUNT_TABS).map(([k, v]) => [v, k]));
const PUBLIC_FIRST = new Set([...Object.values(FIRST), "admin"]);

export function toPublic(path) {
  const [p, rest = ""] = path.split(/(?=[?#])/);
  const segs = p.split("/").filter(Boolean);
  if (segs[0] === "pl") segs.shift();
  if (!segs.length) return "/" + rest;
  const [a, b] = segs;
  const out = [FIRST[a] || a];
  if (b !== undefined) out.push(SECOND[a]?.[b] || b);
  return "/" + [...out, ...segs.slice(2)].join("/") + rest;
}

export const lp = (to) => (typeof to === "string" && to.startsWith("/") ? toPublic(to) : to);

export function legacyTarget(pathname) {
  const target = toPublic(pathname);
  const first = target.split("/")[1] || "";
  return target !== pathname && (target === "/" || PUBLIC_FIRST.has(first)) ? target : null;
}
